import React, { FC } from 'react'
import { Switch } from 'react-router-dom'

const project = process.env.REACT_APP_PROJECT_NAME
const frontend = require(`@/${project}/router/frontend`).default

 const APP:FC = () => {
  return (
    <Switch>
      {frontend}
    </Switch>
  )
}

export default APP
